import React, { Fragment } from 'react'
import { ThemeProvider } from 'styled-components'
import { defaultTheme, GlobalStyles } from '@sl/ui-library'
import { slFontFace } from '@ui-library/sl/lib/font-face'

const defaultThemeUpdated = {
  ...defaultTheme,
  fontFace: slFontFace,
  fontFamily: "'Cera SL', 'Helvetica', 'Arial', 'sans-serif'",
}

const Layout = ({ children, ...props }) => (
  <ThemeProvider theme={defaultThemeUpdated}>
    <Fragment {...props}>
      <GlobalStyles />
      {children}
    </Fragment>
  </ThemeProvider>
)

export default Layout
